import {
  DetailsListLayoutMode,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { TableBase } from "../../../components/Table/TableBase";
import plantillaVerificacionService from "../../../services/plantillaVerificacion/plantillaVerificacionService";
import {
  baseSearch,
  _initialFilter,
  _initialPagination,
} from "../../../utils/helpers/helpers";
import IconHelper from "../../../utils/helpers/iconHelper";
import { useBoolean } from "@fluentui/react-hooks";
import {
  IBodyUpdatePlantilla,
  IPlantillaVerificacion,
} from "../../../Interfaces/IPlantillaVerificacion";
import DetallePlantillaCheckList from "./DetallePlantillaCheckList";
import themeBase from "../../../utils/theme/themeBase";
import { IHeaderTitlesText } from "../../../Interfaces/IPanel";
import DialogDeleteBase from "../../../components/generic/DialogDeleteBase";
import { HeadingBar } from "../../../components/generic/HeadingBar";
import { Ifilter } from "../../../Interfaces/filter";
import { IPagination } from "../../../Interfaces/base/ITable";
import Estado from "../../../components/elements/Estado";
import { PanelCrearCheckList } from "./PanelCrearCheckList";
import { PanelEditarPlantillaCheckList } from "./PanelEditarPlantillaCheckList";

function ListaVerificacionVita() {
  const [plantillasVerificacion, setPlantillasVerificacion] = useState<
    IPlantillaVerificacion[]
  >([]);
  const [isOpenDtalle, { setTrue: openDetalle, setFalse: dismissDetalle }] =
    useBoolean(false);
  const [isDataLoad, { setTrue: dataLoad, setFalse: noDataLoad }] =
    useBoolean(false);

  const [filter, setFilter] = useState<Ifilter>(_initialFilter);
  const [searchParam, setSearchParam] = useSearchParams();

  /**CREAR NUEVA PLANTILLA CHECKLIST*/
  const [isOpenNuevo, { setTrue: openNuevo, setFalse: dismissNuevo }] =
    useBoolean(false);

  const [selectItemTable, setselectItemTable] =
    useState<IPlantillaVerificacion>();
  /**Actulizar PLANTILLA CHECKLIST*/
  const [bodyUpdatePlantilla, setBodyUpdatePlantilla] =
    useState<IBodyUpdatePlantilla>({});

  /**CONFIRMAR UNA ELIMINACION */
  const [hidePDF, { toggle: toggleHidePDF }] = useBoolean(true);
  const [hidePropressDelete, { toggle: PropressDelete }] = useBoolean(false);

  /**PAGINACION*/
  const [currentPage, setCurrentPage] = useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
  const [total, setTotal] = useState(_initialPagination().total);

  const [pagIngreso, setPagIngreso] = useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => setCurrentPage(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  //CAPTURA DE TAMAÑO DE PAGINA
  const _getPageSize = (value: number) => {
    setPageSize(value);
    setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value });
    setPagIngreso({ ...pagIngreso, pageSize: value });
  };
  /* Hook Pagination */
  useEffect(() => {
    dataPlantillaVerificacion(filter);
  }, [filter.skip, pageSize]);

  useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      currentPage: currentPage,
    });
    /* Solo si no es la primera carga actualiza el paginador */
    if (currentPage >= 1) {
      if (filter) {
        setFilter({
          ...filter,
          skip: (currentPage - 1) * pageSize,
          take: pageSize,
        });
      }
    }
  }, [currentPage]);

  useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      total: total,
    });
  }, [total]);

  const dataPlantillaVerificacion = useCallback((filter?: Ifilter) => {
    noDataLoad();
    setPlantillasVerificacion([]);
    plantillaVerificacionService.plantillasVerificacion(filter).then((res) => {
      setTotal(res.data.total);
      setPlantillasVerificacion(res.data.items);
      dataLoad();
    });
  }, []);

  const panelDetalleHeaderText: IHeaderTitlesText = {
    title: "Detalle Checklist",
    subTitle: selectItemTable?.nombre,
  };

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: openNuevo,
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        setFilter(_initialFilter());
        dataPlantillaVerificacion(filter);
      },
    },
  ];
  const _columns = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 300,
      isResizable: true,
      onRender: (item: IPlantillaVerificacion) => (
        <>
          <span>{item.nombre}</span>
        </>
      ),
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IPlantillaVerificacion) => (
        <Estado value={item.activo ? "Inactivo" : "Activo"} />
      ),
    },
    {
      key: "modeloEquipo",
      name: "Modelo Equipo",
      fieldName: "equipoModelo",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "fechaCreacion",
      name: "Fecha Creacion",
      fieldName: "fechaCreacion",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "value",
      name: "Opciones",
      fieldName: "value",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IPlantillaVerificacion) => (
        <>
          <TooltipHost content={`Editar`}>
            <Icon
              iconName="Edit"
              className={themeBase.classNamesIcon.iconFont}
              style={iconDetalleStyle}
              onClick={() => {
                setselectItemTable(item);
                openDetalle();
              }}
            />
          </TooltipHost>
          <TooltipHost content={`Quitar`}>
            <Icon
              iconName="delete"
              className={themeBase.classNamesIcon.iconFont}
              style={iconDeleteStyle}
              onClick={() => {
                setselectItemTable(item);
                toggleHidePDF();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  const DeletePlantilla = useCallback((PantillaVerificacionId: string) => {
    PropressDelete();
    plantillaVerificacionService
      .DeletePlantilla(PantillaVerificacionId)
      .then((res) => {
        dataPlantillaVerificacion(filter);
        PropressDelete();
        toggleHidePDF();
      })
      .catch((e: Error) => {
        alert(e);
        PropressDelete();
        toggleHidePDF();
      });
  }, []);

  const confirmDelete = () => {
    if (selectItemTable)
      DeletePlantilla(selectItemTable?.plantillaListaVerificacionId);
    else alert("Id vacio o nulo ");
  };
  /**Actualizar Plantilla Verificacion*/
  const UpdatePlantilla = () => {
    plantillaVerificacionService
      .ActulizarPlantilla(bodyUpdatePlantilla)
      .then((res) => {
        dismissDetalle();
        setFilter(_initialFilter());
        dataPlantillaVerificacion(_initialFilter());
      })
      .catch((e: Error) => {
        alert(e.message);
      });
  };

  /**EVENTOS FILTER */
  const _onChangeText = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setSearchParam({
        [baseSearch]: newValue,
      });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };
  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
    setSearchParam({
      [baseSearch]: "",
    });
  };
  const _onPress = (newValue: string) => {
    if (newValue != undefined) {
      setFilter({
        ...filter,
        search: newValue,
      });
    }
  };
  const _getFilter = () => {
    return searchParam.get(baseSearch) ?? "";
  };

  useEffect(() => {
    dataPlantillaVerificacion(filter);
  }, [filter.search]);

  return (
    <>
      <HeadingBar
        title="CheckList"
        subTitle="Gestión de CheckList"
        searchPlaceholder="Buscar Nombre"
        searchChange={_onChangeText}
        searchHandler={_onPress}
        searchValue={_getFilter()}
        onClearHandler={_onClearSearch}
      />
      <br />
      <TableBase
        leftBar={_items}
        isLoading={!isDataLoad}
        data={plantillasVerificacion}
        column={_columns}
        getPageSize={_getPageSize}
        layout={DetailsListLayoutMode.justified}
        pagination={pagIngreso}
      />
      <PanelCrearCheckList isOpen={isOpenNuevo} onDismiss={dismissNuevo} />
      <PanelEditarPlantillaCheckList
        isOpen={isOpenDtalle}
        onDismiss={dismissDetalle}
        plantilla={selectItemTable}
      />
      {/*  <PanelGenerico
        isOpen={isOpenDtalle}
        onDismiss={dismissDetalle}
        cancelar={dismissDetalle}
        registrar={UpdatePlantilla}
        HeaderTitlesText={panelDetalleHeaderText}
        enabledHeader
        // enabledFooter
        objectRenderBodyHelp={bodyUpdatePlantilla}
        textRegister="Actualizar"
      >
        <DetallePlantillaCheckList
          getBodyUpdate={setBodyUpdatePlantilla as (body) => void}
          idPlantilla={selectItemTable?.plantillaListaVerificacionId}
        />
      </PanelGenerico> */}

      <DialogDeleteBase
        hidden={hidePDF}
        onDismiss={toggleHidePDF}
        eliminar={confirmDelete}
        cancelar={toggleHidePDF}
        hidePropressDelete={hidePropressDelete}
      />
    </>
  );
}

export default ListaVerificacionVita;

const iconDeleteStyle: React.CSSProperties | undefined = {
  cursor: "pointer",
  color: "#bebbb8",
};
const iconDetalleStyle: React.CSSProperties | undefined = {
  cursor: "pointer",
  color: "#0078d4",
};
